module.exports = __webpack_public_path__ + "img/change-icon.fb300ea7.svg";